import React, {useMemo} from "react";
import {FaCheck} from "react-icons/fa";
import {FaTriangleExclamation} from "react-icons/fa6";
import ReferenceImportModal from "../../../../../components/reference-import-modal/reference-import-modal.jsx";
import neighborhoodService from "../../../../../services/web/neighborhood-service.js";

const NeighborhoodImport = ({open, setOpen, refetch, setIsLoading}) => {
    const columnDefs = useMemo(() => {
        const reasonLabels = {
            "neighborhood.import.name.empty": "Nome vazio.",
            "neighborhood.import.name.duplicated": "Nome repetido na planilha.",
            "neighborhood.import.name.already.used": "Bairro já cadastrado."
        };

        return [
            {headerName: "", field: "status", width: 56, sortable: false, cellRenderer: ({value}) => <div className="flex h-full items-center justify-center">{value === "NEW" ? <FaCheck color="#219453"/> : <FaTriangleExclamation color="#ed5565"/>}</div>},
            {headerName: "Linha", field: "row", width: 90},
            {headerName: "Nome", field: "name", flex: 1, minWidth: 220},
            {headerName: "Status", field: "status", width: 120, valueFormatter: ({value}) => value === "NEW" ? "Novo" : "Ignorado"},
            {headerName: "Motivo", field: "reason", flex: 1, minWidth: 240, valueFormatter: ({value}) => reasonLabels[value] ?? value}
        ];
    }, []);

    const getPreviewErrorMessage = (error) => {
        const messages = {
            "neighborhood.import.file.structure.invalid": "A planilha de importação não corresponde ao formato exigido. Utilize o modelo disponibilizado.",
            "neighborhood.import.file.type.invalid": "Selecione um arquivo Excel válido.",
            "neighborhood.import.file.invalid": "O arquivo Excel é inválido ou não pode ser lido.",
            "neighborhood.import.file.size.invalid": "O arquivo excede o limite de 5 MB.",
            "neighborhood.import.rows.limit.exceeded": "A planilha excede o limite de 5.000 linhas."
        };

        return messages[error.response?.data?.message] ?? "Não foi possível gerar a prévia da importação.";
    };

    const downloadTemplate = () => {
        window.location.href = neighborhoodService.importTemplateUrl();
        return Promise.resolve();
    };

    const buildPayload = (rows) => ({neighborhoods: rows.filter(({status}) => status === "NEW").map(({name}) => name)});

    return <ReferenceImportModal
        open={open}
        setOpen={setOpen}
        refetch={refetch}
        setIsLoading={setIsLoading}
        title="Importação de bairros"
        columnDefs={columnDefs}
        previewImport={neighborhoodService.importPreview}
        createImport={neighborhoodService.createImport}
        buildPayload={buildPayload}
        downloadTemplate={downloadTemplate}
        getPreviewErrorMessage={getPreviewErrorMessage}
        successMessage={(created, ignored) => `Importados: ${created}<br>Não importados: ${ignored}`}
        successTitle="Bairro"
        importErrorMessage="Não foi possível importar os bairros."
        templateErrorMessage="Não foi possível baixar o modelo de importação."
    />;
};

export default NeighborhoodImport;
